var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.isReadOnly
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-end" },
            [
              _c("action-button", {
                attrs: {
                  i: "fas fa-file-plus",
                  text: "Añadir Prueba",
                  variant: "success pl-3 pr-3 my-3"
                },
                on: {
                  click: function($event) {
                    return _vm.add()
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c("validation-provider", {
        attrs: { name: "Información de prueba", rules: "required" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({ errors }) {
              return [
                _c("input", {
                  attrs: { type: "hidden" },
                  domProps: {
                    value:
                      _vm.model.infoTests && _vm.model.infoTests.length
                        ? "OK"
                        : ""
                  }
                }),
                errors[0]
                  ? _c("div", { staticClass: "custom-error mb-2" }, [
                      _c("i", { staticClass: "fas fa-times-circle mr-2" }),
                      _vm._v(
                        " Debe agregar al menos una información de prueba antes de guardar. "
                      )
                    ])
                  : _vm._e(),
                _vm._l(_vm.model.infoTests, function(item) {
                  return _c(
                    "div",
                    { key: item.id || item._uid, staticClass: "mb-4" },
                    [
                      _c(
                        "div",
                        { staticClass: "bg-light p-3 rounded" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center mb-2"
                            },
                            [
                              _c("label", { staticClass: "text-muted" }, [
                                _vm._v("Información de Prueba:")
                              ]),
                              !_vm.isReadOnly
                                ? _c("i", {
                                    staticClass:
                                      "far fa-times-circle text-danger",
                                    on: {
                                      click: function($event) {
                                        return _vm.remove(item)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-text-area", {
                                        attrs: {
                                          "count-classes": [
                                            "d-block",
                                            "small-counter",
                                            "text-right"
                                          ],
                                          "custom-error-msg":
                                            "El campo es requerido",
                                          disabled: _vm.isReadOnly,
                                          error: errors[0],
                                          maxlength: 5000,
                                          "show-char-count": !_vm.isReadOnly
                                        },
                                        model: {
                                          value: item.comment,
                                          callback: function($$v) {
                                            _vm.$set(item, "comment", $$v)
                                          },
                                          expression: "item.comment"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      )
                    ]
                  )
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }